import { render, staticRenderFns } from "./EmailRecipient.vue?vue&type=template&id=6565ce16"
import script from "./EmailRecipient.vue?vue&type=script&lang=js"
export * from "./EmailRecipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports